export class PartnerContractTemplate {
  constructor(id, code, title, apiUsageLimit, permissions) {
    this.id = id;
    this.code = code;
    this.title = title;
    this.apiUsageLimit = apiUsageLimit;
    this.permissions = permissions;
  }
}
export class PartnerContract {
  constructor(id, title, startDateTime, endDateTime, apiUsageLimit, contractTemplateId, companyMaxSize, stripeInvoices, stripeSubscriptionId, automaticallyRenew) {
    this.id = id;
    this.title = title;
    this.startDateTime = startDateTime;
    this.endDateTime = endDateTime;
    this.apiUsageLimit = apiUsageLimit;
    this.contractTemplateId = contractTemplateId;
    this.companyMaxSize = companyMaxSize;
    this.stripeInvoices = stripeInvoices;
    this.stripeSubscriptionId = stripeSubscriptionId;
    this.automaticallyRenew = automaticallyRenew;
  }
}